import { getApiUrl } from './apiConfig';

let cache = {
  studentId: null,
  profile_picture_url: null,
  updatedAt: 0,
};

const TTL_MS = 45_000;

/** Drop cached avatar URL (full clear if studentId omitted). Call after logout or profile photo upload. */
export function invalidateStudentProfilePictureCache(studentId) {
  if (studentId == null) {
    cache = { studentId: null, profile_picture_url: null, updatedAt: 0 };
    return;
  }
  const id = Number(studentId);
  if (!Number.isNaN(id) && cache.studentId === id) {
    cache = { studentId: null, profile_picture_url: null, updatedAt: 0 };
  }
}

/**
 * Latest profile_picture_url for a student from GET /api/users/:id (cached briefly).
 */
export async function fetchStudentProfilePictureUrl(studentId, { force = false } = {}) {
  const id = Number(studentId);
  if (Number.isNaN(id)) return null;

  const now = Date.now();
  if (
    !force &&
    cache.studentId === id &&
    now - cache.updatedAt < TTL_MS
  ) {
    return cache.profile_picture_url;
  }

  try {
    const res = await fetch(
      `${getApiUrl()}/api/users/${encodeURIComponent(String(id))}`
    );
    let data = {};
    try {
      data = await res.json();
    } catch {
      /* ignore */
    }
    if (!res.ok || data?.error || data?.id == null) {
      return cache.studentId === id ? cache.profile_picture_url : null;
    }
    const raw = data.profile_picture_url;
    const url =
      raw != null && String(raw).trim() !== '' ? String(raw).trim() : null;
    cache = { studentId: id, profile_picture_url: url, updatedAt: now };
    return url;
  } catch {
    return cache.studentId === id ? cache.profile_picture_url : null;
  }
}
